export interface CrmTicketDto {
  id: string;
  originTicketId: string | null;
  installationInformation: {
    contactInformation: {
      bestWayOfContact: string | null;
      bestTimeToContact: string | null;
      meansToContact: string | null;
      meansToContactTheResponsibleForInstallation: string | null;
    };

    clientInformation: {
      email: string | null;
      phoneNumber: string | null;
      name: string | null;
      responsibleForTrackingScheduling: string | null;
      installationDoneByClient: boolean | null;
      installationProblem: string | null;
    };

    deviceInformation: {
      esns: string | null;
      installedEsns: string | null;
      notInstalledEsns: string | null;
      type: string | null;
      esnToInstall: string | null;
      esnToNotInstall: string | null;
      heavyOrLightVehiclesInstalledQuantityCoblicam: number | null;
      motorcyclesOrHeavyVehiclesInstalledQuantity: number | null;
      heavyOrLightVehiclesInstalledQuantity: number | null;
      lightVehiclesInstalledBlockerQuantity: number | null;
      heavyOrLightVehiclesInstalledIdentifierQuantity: number | null;
      heavyOrLightVehiclesInstalledImmobilizerQuantity: number | null;
      calculatedInstallDevices: number;
    };

    dateInformation: {
      scheduledDay: string | null;
      clientFirstPreferredScheduleDay: string | null;
      clientSecondPreferredScheduleDay: string | null;
      scheduledDateTime: string | null;
      clientFirstPreferredScheduleHour: string | null;
      clientSecondPreferredScheduleHour: string | null;
      installedDate: string | null;
      installationConfirmedAt: string | null;
    };

    coblerInformation: {
      responsible: string | null;
      responsibleScheduling: string | null;
      responsibleToContactClient: string | null;
      technicalResponsible: string | null;
    };

    fieldControlInformation: {
      worker: string | null;
      fieldControlObservation: string | null;
      observationToTheTechnicalTeam: string | null;
      fieldAssociation: string | null;
      fieldClass: string | null;
    };

    addressInformation: {
      postalCode: string | null;
      addressConfirmation: string | null;
    };

    shippingInformation: {
      trackingCode: string | null;
      shippingCompany: string | null;
      address: string | null;
      estimatedReceivingDate: string | null;
    };

    vehicleInformation: {
      plack: string | null;
      vehicles: string | null;
    };

    responsibleUser: {
      id: string | null;
      name: string | null;
      email: string | null;
      fleetIds: string[] | null;
      createdAt: string | null;
      updatedAt: string | null;
    };
    ratedAt: string | null;
    fleetId: string | null;
    scheduledDay: string | null;
    scheduledDateTime: string | null;
    installedDate: string | null;
    installationConfirmedAt: string | null;
  };

  devolutionInformation: {
    fleetId: string | null;
    fleetName: string | null;
    type: string | null;
    penaltyPrice: number | null;
    devolutionDeadline: string | null;
    clientInformation: {
      clientCnpj: string | null;
    };

    shippingInformation: {
      devolutionPostageDate: string | null;
      devolutionArrivalOfDevicesAtCobli: string | null;
      devolutionShippingCodeOrScheduleDate: string | null;
      devolutionShippingCode: string | null;
      devolutionShippingType: string | null;
    };

    deviceInformation: {
      devolutionDevicesEsn: string | null;
      lightDevolutionInstalledBlockerQuantity: number | null;
      heavyOrLightDevolutionInstalledQuantity: number | null;
      heavyOrLightDevolutionInstalledBuzzerQuantity: number | null;
      heavyOrLightDevolutionInstalledCoblicamQuantity: number | null;
      heavyOrLightDevolutionInstalledImmobilizerQuantity: number | null;
      motorcycleOrMachineryDevolutionInstalledQuantity: number | null;
      lightDevolutionRemovableQuantity: number | null;
      heavyDevolutionRemovableQuantity: number | null;
      heavyOrLightDevolutionRemovableBuzzerQuantity: number | null;
      heavyOrLightDevolutionRemovableIdentifierQuantity: number | null;
      motorcycleOrMachineryDevolutionInstalledClientQuantity: number | null;
      heavyOrLightDevolutionInstalledIdentifierQuantity: number | null;
    };
  };

  closedDate: string | null;
  content: string | null;
  createDate: string | null;
  conclusionDate: string | null;
  lastActivityDate: string | null;
  lastModifiedDate: string | null;
  nextActivityDate: string | null;
  pipeline: string | null;
  pipelineStage: string | null;
  priority: string | null;
  notesLastUpdated: string | null;
  notesNextActivityDate: string | null;
  sourceType: string | null;
  subject: string | null;
  ticketAssociatedDealId: string | null;
  resolution: string | null;
  panelFormTest: boolean | null;
}

export interface CrmReportProblemTicket {
  id: string | null;
  createdAt: string | null;
  properties: {
    subject: string | null;
  };
}

export interface CrmReportProblemTicketsDto {
  tickets: CrmReportProblemTicket[];
  total: number;
}

export interface CrmTicketsDto {
  tickets: CrmTicketDto[];
  total: number;
}

export enum UpsellItem {
  DEVICE = 'device',
  IBUTTON = 'ibutton',
}

export enum DevolutionPipelineStage {
  CANCELLED_DEVOLUTION = '941453', // devolução cancelado
  REQUEST_DEVOLUTION = '525139', // Solitação de Devolução
  STAND_BY = '4017858', // Stand by
  WAITING_TECHNICIAN_TO_UNINSTALL = '30093849', // Aguardando técnico desinstalar
  NOT_RETURNED = '388903', // Não serão devolvidos - Em cobrança
  POSTAGE_CODE = '388867', // Código de postagem
  OPENING_TICKET = '93500850', // [DEVOLUÇÃO] - ABERTURA DE TÍQUETE
  CONFIRM_POSTAGE = '388868', // Confirmar postagem
  PARTIAL_DEVOLUTION = '11997579', // Devolução Parcial
  VALIDATION_SUPPORTS = '85094147', // Validação - Suportes
  CLOSING_TICKET = '93500852', // [DEVOLUÇÃO] - Fechamento de tíquete
  WAITING_FOR_CONFERENCES = '388901', // Aguardando Conferência
  NO_SHOW = '115351864', // No show
  CLOSED = '388902', // Concluido
  CONFIRMING_INFORMATION = '388864', // Confirmando informações
  CONTACT_REALIZED_WITH_CUSTOMER = '30093848', // Contato realizado com o cliente
  SCHEDULE_UNINSTALLATION = '21728796', // Agendar Desinstalação
  TREATING_TICKET = '93500851', // [DEVOLUÇÃO] - Tratativa de tíquete
  ON_THE_WAY = '388900', // A caminho
}
